import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

import { useApp } from '@/presentation/hooks/use-app.js';

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: () => Promise<boolean>;
}

export function DeleteClientDocumentDialog({ open, onClose, onConfirm }: Props) {
    const { translate } = useApp();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleConfirm = async () => {
        setError('');
        setLoading(true);
        try {
            const shouldClose = await onConfirm();
            if (shouldClose) {
                onClose();
            }
        } catch {
            setError(translate('errors.generic'));
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        if (loading) {
            return;
        }
        setError('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>{translate('common.confirmDelete')}</DialogTitle>
            <DialogContent>
                <Typography variant="body2">{translate('common.delete')}?</Typography>
                {error && (
                    <Typography variant="caption" color="error" sx={{ display: 'block', mt: 1 }}>
                        {error}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading} sx={{ textTransform: 'none' }}>
                    {translate('common.cancel')}
                </Button>
                <Button color="error" variant="contained" onClick={handleConfirm} disabled={loading} sx={{ textTransform: 'none' }}>
                    {translate('common.delete')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
